export default __webpack_public_path__ + "static/assets/images/amgen-foundation.6d814efd2f498874e53f25de2d2cdcce.png";